"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FX_CURRENCY_PAIRS = exports.FX_HEDGE_BASE_CURRENCIES = exports.FX_QUOTE_CURRENCY = exports.HEDGEABLE_ASSET_LABELS = exports.HEDGING_ASSET_DISPLAY_ORDER = exports.COMMODITY_TO_ASSET = exports.HEDGEABLE_ASSETS = void 0;
exports.hedgeableAssetLabel = hedgeableAssetLabel;
exports.commodityToAsset = commodityToAsset;
exports.isHedgeableAsset = isHedgeableAsset;
exports.isFxCurrencyPair = isFxCurrencyPair;
// **Keyed by the PRISMA ENUM IDENTIFIER, not the database value**, because that is what a read
// emits. Two of the ten commodities differ between the two — `Mixed_metals` is stored as
// "Mixed metals" and `Nickel_stainless_hi_temp` as "Nickel/stainless/hi-temp" — and nickel is the
// only one of the pair carrying an LME asset, so keying on the stored spelling resolved every
// nickel cargo to "not hedgeable": absent from exposure, from the asset filters and from the
// metal-match checks. Both spellings are accepted so a caller holding a raw database value still
// resolves, but the identifiers are the contract. See fence-projection.ts, which hit the same trap.
const HEDGEABLE_COMMODITY_TO_ASSET = {
    Copper: 'CU',
    Aluminium: 'AL',
    Zinc: 'ZN',
    Lead: 'PB',
    Nickel_stainless_hi_temp: 'NI',
    'Nickel/stainless/hi-temp': 'NI',
    Brass: 'CU',
};
exports.HEDGEABLE_ASSETS = ['CU', 'AL', 'ZN', 'NI', 'PB', 'SN'];
// Maps physical commodity_type values to the LME underlying code used as the
// hedging desk's `asset` key. Commodities without an LME hedge are intentionally
// absent so they do not contribute hedgeable MT to risk cards or filters.
exports.COMMODITY_TO_ASSET = HEDGEABLE_COMMODITY_TO_ASSET;
exports.HEDGING_ASSET_DISPLAY_ORDER = ['CU', 'AL', 'ZN', 'NI', 'PB', 'SN', 'FX'];
// Plain-English names for the LME underlyings, so a message written for a
// trader or a lender reads "copper" rather than the desk's ticker.
exports.HEDGEABLE_ASSET_LABELS = {
    CU: 'copper',
    AL: 'aluminium',
    ZN: 'zinc',
    NI: 'nickel',
    PB: 'lead',
    SN: 'tin',
};
function hedgeableAssetLabel(value) {
    return isHedgeableAsset(value) ? exports.HEDGEABLE_ASSET_LABELS[value] : null;
}
function isHedgeableCommodity(value) {
    return Object.prototype.hasOwnProperty.call(exports.COMMODITY_TO_ASSET, value);
}
function commodityToAsset(commodity) {
    if (!commodity)
        return null;
    return isHedgeableCommodity(commodity) ? exports.COMMODITY_TO_ASSET[commodity] : null;
}
function isHedgeableAsset(value) {
    return (value !== null && value !== undefined && exports.HEDGEABLE_ASSETS.includes(value));
}
// ── FX currency pairs ───────────────────────────────────────────────────────
// Every FX hedge converts a deal's own currency into USD, so a pair is always
// <deal currency>/USD. `currency_pair` on a hedge request used to be free text,
// which produced silent holes: attribution matches the pair's first three
// letters against the leg's ticket currency, so one mistyped pair ("EUD/USD" on
// 101245 / 101246) detaches the hedge from its deal — the tape then reports the
// leg as never hedged. The list below is the only accepted set, on both the
// form and the API, so a malformed pair cannot be entered at all (Fizzy #949).
//
// The bases mirror the frequent-currency codes offered elsewhere in the app,
// minus USD (a USD leg needs no conversion and never carries a pair).
exports.FX_QUOTE_CURRENCY = 'USD';
exports.FX_HEDGE_BASE_CURRENCIES = [
    'EUR',
    'CHF',
    'GBP',
    'INR',
    'AED',
    'SGD',
    'JPY',
    'CNY',
];
exports.FX_CURRENCY_PAIRS = exports.FX_HEDGE_BASE_CURRENCIES.map((base) => `${base}/${exports.FX_QUOTE_CURRENCY}`);
function isFxCurrencyPair(value) {
    return (value !== null &&
        value !== undefined &&
        exports.FX_CURRENCY_PAIRS.includes(value));
}
//# sourceMappingURL=hedging.js.map